// Package imports
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import find from "lodash/find";
import Grid from "@mui/material/Grid";
import ListCard from "../ListCard";
import { makeStyles } from "@material-ui/core/styles";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import { currentAssetSliceActions } from "../../Store/Slices/CurrentAssetSlice";

// Custom imports

// Global variables

// Component
const Intermediate = (props) => {
  // Hooks
  const navigation = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  let { id } = useParams();

  // State
  const [sessionData, setSessionData] = useState(null);
  const [alertFlag, setAlertFlag] = useState(false);

  // Redux state
  const product = useSelector((state) => state.product.productData);
  const language = useSelector((state) => state.product.language);
  let coursePermissions = useSelector(
    (state) => state.defs.siteConfig.products[0]["coursePermissions"]
  );

  // React logic hooks
  useEffect(() => {
    let sessions;
    let languageTitle;
    if (language > -1) {
      languageTitle = JSON.parse(product[0]["course_data"])["data"][0]["data"][
        language
      ]["value"];
      sessions = find(
        JSON.parse(product[0]["course_data"])["data"][0]["data"][language][
          "data"
        ],
        { id: id }
      );
    } else {
      sessions = find(
        JSON.parse(product[0]["course_data"])["data"][0]["data"],
        { id: id }
      );
    }
    if (sessions) {
      setSessionData(sessions);
      if (languageTitle) {
        dispatch(
          commonSliceActions.setBreadcrumb(
            `${languageTitle} | ${sessions.value}`
          )
        );
      } else {
        dispatch(commonSliceActions.setBreadcrumb(`${sessions.value}`));
      }
    }
  }, [id, product]);

  // Route redirect function
  const redirect = (obj) => {
    console.log(location.pathname);
    if (obj.data.length == 0) {
      setAlertFlag(true);
      return false;
    }

    if (location.pathname.includes("Teach")) {
      navigation(`/Teach/Leaf/${id}/${obj.id}`);
    } else if (location.pathname.includes("Task")) {
      if (location.pathname.includes("Create")) {
        navigation(`/Task/Create/Leaf/${id}/${obj.id}`);
      } else {
        navigation(`/Task/Edit/Leaf/${id}/${obj.id}`);
      }
    }

    // switch (route.name) {
    //   case "Session":
    //     navigation.navigate("Teach", {
    //       screen: "LeafList",
    //       params: { moduleId: route.params.id, id: obj.id },
    //     });
    //     break;
    //   case "CreateTaskSession":
    //     navigation.navigate("Task", {
    //       screen: "CreateTaskLeaf",
    //       params: { moduleId: route.params.id, id: obj.id },
    //     });
    //     break;
    // }
  };

  const classes = useStyles();

  // JSX template
  return (
    <Grid
      item
      xs={12}
       
      sx={{ overflow: "auto", height: "81vh" }}
    >
      <Grid sx={{ position: "relative" }}>
        <Grid
          container
          sx={{
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            mt: 1,
            py: 3,
            overflow: "auto",
          }}
        >
          {sessionData &&
            sessionData.data
              .filter((val) => {
                return (
                  coursePermissions &&
                  coursePermissions.indexOf(val.value) == -1
                );
              })
              .map((obj, index) => {
                return (
                  <Grid xs={6} key={"session_" + index} sx={{ px: 6 }}>
                    <ListCard text={obj.value} press={() => redirect(obj)} />
                  </Grid>
                );
              })}
        </Grid>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default Intermediate;
